<template>
  <app-page-title :color="'sun'">
    <template #pageTitleLeft>
      <h1>Invoice #: {{invoiceNumber}}</h1>
    </template>
    <template #pageTitleRight>
      <router-link class="_mls" :to="{name: 'billing-overview'}">Billing Home</router-link>
      <router-link
        class="_mls btn --sm"
        v-if="!isInternalUser && paymentsAvailable && openAmount > 0"
        :to="{ name: 'make-payment' }"
      >
        make payment
      </router-link>
    </template>
  </app-page-title>
</template>

<script>
  import AppPageTitle from '@sections/PageTitle'
  import { mapGetters } from 'vuex'
  import billing from '@mixins/billing'

  export default {
    mixins: [billing],
    props: {
      openAmount: {
        type: Number
      },
      invoiceNumber: {
        type: String
      }
    },
    components: {
      AppPageTitle
    },
    computed: {
      ...mapGetters(['isInternalUser', 'paymentsAvailable'])
    }
  }
</script>
